<template>
  <div class="series-view-wrap">
    <div
      v-if="list.length === 0"
      class="image-slot">
      <i
        class="el-icon-picture-outline"
        style="font-size:40px;"></i>
    </div>
    <template v-else>
      <el-row
        :gutter="12"
        style="width: 100%;">
        <el-col
          v-for="item in list"
          :key="item.id"
          :span="12">
          <div class="service-card">
            <div class="service-image-wrap">
              <img
                :src="item.image"
                class="service-image">
            </div>
            <div class="title">{{ item.servOrgName }}</div>
            <div class="sub-title">{{ item.introduction }}</div>
          </div>
          <!-- <div class="service-org-card">
            <img
              :src="item.image"
              class="service-org-img">
            <div class="service-org-detail">
              <div class="service-org-name">{{ item.servOrgName }}</div>
              <div class="service-org-desc">{{ item.introduction }}</div>
            </div>
          </div> -->
        </el-col>
      </el-row>
    </template>
  </div>
</template>
<script>
export default {
  name: 'WeSeriesView',
  props: {
    list: { type: Array, default() { return [] } }
  }
}
</script>
<style lang="stylus" scoped>
  .image-slot {
    width 100%
    height: 100px
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f5f7fa;
    color: #909399;
  }
.series-view-wrap {
  min-height: 100px
  padding: 0 8px;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto
}
.service-org-card {
    display: flex;
  align-items: center;
  padding: 8px;
}
.service-org-img {
  width 35%
  flex: 0 0 35%;
  padding-right: 8px;
}

.service-org-detail {
  flex: 1;
  min-width: 0;
}

.service-org-name {
  font-size: 15px;
  color: #333;
  line-height: 18px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.service-org-desc {
  font-size: 13px;
  line-height: 18px;
  color: #999;
  display: -webkit-box; /* 对象作为弹性盒子模型显示 */
  overflow: hidden; /* 溢出隐藏 */
  -webkit-box-orient: vertical; /* 设置伸缩盒子对象的子元素的排列方式 */
  -webkit-line-clamp: 3; /* 设置块元素包含的文本行数 */
}

.service-card {
  margin-bottom: 8px;
}
.service-image-wrap {
  position relative
  padding-top: 60%;
}
.service-image {
    position absolute
    left: 0;
    top: 0
    width: 100%
    height: 100%
    object-fit: cover;
}
.title,.sub-title {
  text-overflow: ellipsis
  white-space: nowrap
  overflow hidden
}
.title {
  font-size: 14px;
  color: #47506d;
  line-height: 20px;
}
.sub-title {
  font-size: 12px;
  color: #8791b2;
  line-height: 18px;
  padding-top: 4px;
}
</style>
